import { createSelector } from 'reselect'
import { formIdFromAnswersHubSelector } from './hub'
import { RootState } from '../types/rootstate'

const suggestSelector = (state: RootState) => state.suggest

export const currentSuggestStatusSelector = createSelector(
  [ suggestSelector, formIdFromAnswersHubSelector ],
  (suggest, formId) => {
    const item = suggest[formId]
    return (item && item.status) || 'none'
  }
)

export const currentSuggestResultsSelector = createSelector(
  [ suggestSelector, formIdFromAnswersHubSelector ],
  (suggest, formId) => {
    const item = suggest[formId]
    return (item && item.suggestions) || []
  }
)
